import { ProtectedSearchForm } from "./Components/ApplicantSearch";
import { ThreeColumnPage } from "./Components/ThreeColumnPage";

export function ProtectedSearchPage() {
  return <ThreeColumnPage
    main={<div className="p-10">
      <ProtectedSearchForm />
    </div>}
  />
}
